module.exports = __webpack_public_path__ + "./static/media/reactLogo.4af927e2.png";